import { format } from '@campaign-manager/core/lib/date';
import { MfDate } from '@campaign-manager/core/model';

import { isZeroDate } from '../../date/zero';
import ValuePlaceholder from '../ValuePlaceholder';

interface Props {
  date: MfDate | Date | string | null | undefined;
  placeholder?: string;
}

export default function DateValue(props: Props) {
  return <>{DateValueString(props)}</>;
}

export function DateValueString({ date, placeholder }: Props) {
  const isZero =
    !date || (!(date instanceof MfDate) && !(date instanceof Date) && isZeroDate(date));

  if (isZero) {
    return <ValuePlaceholder placeholder={placeholder} />;
  }

  return format(date);
}
